module.exports = __webpack_public_path__ + "img/xinyi.187cf004.png";